<template>
  <base-page
    v-bind:schemaName="'contact'"
    v-model:entity="entity"
  >
    <template v-slot:panel-left="{ entity }">
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.fullName")
          }}</label>
        <input
          :disabled="true"
          type="text"
          class="form-control"
          v-model="entity.fullName"
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.surname")
          }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.surname"
          required
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.name")
          }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.name"
          required
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.givename")
          }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.givename"
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.mobilePhone")
          }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.mobilePhone"
          required
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.code")
          }}</label>
        <input
          type="text"
          class="form-control"
          v-model="entity.code"
          required
        />
      </div>
      <div class="mb-3 text-left">
        <label class="form-label">{{
          $filters.localize("ContactPage.fields.personalBonus")
          }}</label>
        <input
          type="number"
          class="form-control"
          v-model="entity.personalBonus"
          required
        />
      </div>
    </template>

    <template v-slot:header="{ entity }">
      <div class="contact-page-header">
        <div class="contact-page-header__field text-left">
          <label class="form-label">{{
            $filters.localize("ContactPage.fields.type")
            }}</label>
          <select
            :disabled="types.length === 0"
            class="form-control"
            v-model="entity.typeId"
          >
            <option
              v-for="option in types"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="contact-page-header__field text-left">
          <label class="form-label">{{
            $filters.localize("ContactPage.fields.status")
            }}</label>
          <select
            :disabled="statutes.length === 0"
            class="form-control"
            v-model="entity.statusId"
          >
            <option
              v-for="option in statutes"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
    </template>

    <template v-slot:panel-button="{ entity }">
      <button
        v-if="entity && entity.id"
        type="button"
        class="btn btn-sm btn-outline-primary contact-page-message-button"
        v-on:click="isMessageDialogOpen = true"
      >
        <i class="fas fa-paper-plane"></i>
        <span>{{ $filters.localize("button.send") }} {{
          $filters.localize("MessageDetail.caption") }}</span>
      </button>
    </template>

    <template v-slot:body="{ action, entity }">
      <contact-communication-detail
        v-if="entity && entity.id"
        v-bind:rootId="entity.id"
        v-bind:rootColumn="'ContactId'"
        v-bind:enabled="action == 'update'"
        class="mb-3"
      />
      <transactions-detail
        v-if="entity && entity.id"
        v-bind:rootId="entity.id"
        v-bind:contactId="entity.id"
        v-bind:rootColumn="'ContactId'"
        v-bind:enabled="action == 'update'"
        class="mb-3"
      />
      <message-detail
        v-if="entity && entity.id"
        v-bind:rootId="entity.id"
        v-bind:rootColumn="'ContactId'"
        class="mb-3 contact-page-message-detail"
      />
      <user-detail
        v-if="this.$store.getters.isAdmin && entity && entity.id"
        v-bind:rootId="entity.id"
        v-bind:rootColumn="'ContactId'"
        v-bind:enabled="action == 'update'"
      />
    </template>
  </base-page>

  <div
    v-if="isMessageDialogOpen"
    class="section-modal contact-page-message-modal"
    role="dialog"
    aria-modal="true"
    v-on:click.self="isMessageDialogOpen = false"
  >
    <div class="section-modal__panel">
      <div class="section-modal__header">
        <div>
          <h2>{{ $filters.localize("button.send") }} {{
            $filters.localize("MessageDetail.caption") }}</h2>
        </div>
        <button
          type="button"
          class="section-modal__close"
          v-bind:aria-label="$filters.localize('button.close')"
          v-on:click="isMessageDialogOpen = false"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="section-modal__body">
        <sender-detail
          v-if="entity && entity.id"
          v-bind:contactId="entity.id"
          v-on:sent="isMessageDialogOpen = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SenderDetail from "@/views/details/messages/SenderDetail.vue";
import UserDetail from "@/views/details/users/UserDetail.vue";
import MessageDetail from "@/views/details/messages/MessageDetail.vue";
import TransactionsDetail from "@/views/details/transactions/TransactionsDetail.vue";
import ContactCommunicationDetail from "@/views/details/contacts/ContactCommunicationDetail.vue";
import BasePage from "@/components/Sections/BasePage.vue";
export default {
  name: "ContactPage",
  components: {
    BasePage,
    ContactCommunicationDetail,
    TransactionsDetail,
    MessageDetail,
    UserDetail,
    SenderDetail,
  },
  data() {
    return {
      statutes: [],
      types: [],
      entity: {},
      isMessageDialogOpen: false,
    };
  },
  methods: {
    loadLookups() {
      this.$store
        .dispatch("section", { table: "contactstatus" })
        .then((response) => {
          this.statutes = response.data.data;
        });
      this.$store
        .dispatch("section", { table: "contacttype" })
        .then((response) => {
          this.types = response.data.data;
        });
    },
  },
  mounted() {
    this.loadLookups();
  },
};
</script>

<style scoped>
.contact-page-header {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
}

.contact-page-message-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}

.contact-page-message-button i,
.contact-page-message-button span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1.1;
  text-align: center;
}

.contact-page-message-modal :deep(.sender-form) {
  grid-template-columns: 1fr;
}

.contact-page-message-modal :deep(.sender-form__footer) {
  grid-column: 1;
}

.contact-page-message-detail :deep(.detail-table-wrap) {
  overflow-x: hidden;
}

.contact-page-message-detail :deep(.detail-table) {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
}

.contact-page-message-detail :deep(.detail-table th),
.contact-page-message-detail :deep(.detail-table td) {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.contact-page-message-detail :deep(.detail-table th:first-child),
.contact-page-message-detail :deep(.detail-table td:first-child) {
  width: 145px;
}

.contact-page-message-detail :deep(.detail-value) {
  line-height: 1.25;
}

@media (max-width: 767.98px) {
  .contact-page-header {
    grid-template-columns: 1fr;
  }

  .contact-page-message-detail :deep(.detail-table th:first-child),
  .contact-page-message-detail :deep(.detail-table td:first-child) {
    width: 105px;
  }
}
</style>
